import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DownloadItemType } from '@obo-common/shared/components/downloadSection/downloadItem/downloadItemType.enum';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
    selector: 'shd-download-item',
    templateUrl: './downloadItem.component.html',
    styleUrls: ['./downloadItem.component.scss'],
    standalone: false
})
export class DownloadItemComponent implements OnInit {
    @Input()
    public type: DownloadItemType;
    @Input()
    public href: string;
    @Input()
    public hasBorder: boolean;
    @Output()
    public clicked: EventEmitter<any> = new EventEmitter<any>();
    @Input()
    public label: string;
    @Input()
    public dataTrack: string;
    @Input()
    isDropDown: boolean = false;
    icon: IconProp;

    ngOnInit(): void {
        this.icon = DownloadItemComponent.getIconByType(this.type);
    }

    private static getIconByType(type: DownloadItemType) {
        switch (type) {
            case DownloadItemType.ARCHIVE:
                return 'file-archive';
            case DownloadItemType.PDF:
                return 'file-pdf';
            case DownloadItemType.EXCEL:
                return 'file-excel';
            case DownloadItemType.WORD:
                return 'file-word';
            default:
                return 'file';
        }
    }
}
